const MARK_FREQUENCY_OPTIONS = [
  { value: '__none__', label: '—' },
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Semi-Annual', label: 'Semi-Annual' },
  { value: 'Annual', label: 'Annual' },
];

export const CONFIG_FIELDS = [
  {
    key: 'client' as const,
    label: 'Client',
    placeholder: 'Client short name or code',
    type: 'text' as const,
  },
  {
    key: 'client_legal_name' as const,
    label: 'Client Legal Name',
    placeholder: 'Full legal entity name',
    type: 'text' as const,
  },
  {
    key: 'portfolio_fund' as const,
    label: 'Portfolio/Fund',
    placeholder: 'Main fund or account',
    type: 'text' as const,
  },
  {
    key: 'sub_portfolio' as const,
    label: 'Sub Portfolio',
    placeholder: 'Sub-segment or sub-account',
    type: 'text' as const,
  },
  {
    key: 'reporting_period' as const,
    label: 'Reporting Period',
    placeholder: 'Q# YYYY (e.g., Q1 2024)',
    type: 'text' as const,
  },
  {
    key: 'mark_frequency' as const,
    label: 'Mark Frequency',
    placeholder: 'Select frequency',
    type: 'select' as const,
    selectOptions: MARK_FREQUENCY_OPTIONS,
  },
  {
    key: 'valuation_date' as const,
    label: 'Valuation Date',
    type: 'date' as const,
    required: true,
  },
  {
    key: 'settlement_date' as const,
    label: 'Settlement Date',
    type: 'date' as const,
  },
];
